export default "__VITE_ASSET__CnY0_RPk__"